export default __webpack_public_path__ + "static/media/placeholder.3dfb9031.png";